import $ from 'jquery';
import getParameterByName from '../../../../@infinite/scripts/core/INF-getParameterByName';

export default function() {
  if (getParameterByName('redirect')) {
    $('html.shop-cad [data-region-redirect-notification] p').text('redirected (ca)');
    $('html.shop-cad [data-region-redirect-notification]').fadeIn(400);
    $('html.shop-usd [data-region-redirect-notification] p').text('redirected (us)');
    $('html.shop-usd [data-region-redirect-notification]').fadeIn(400);
  }

  $(document).on('click', '[data-region-redirect-notification] div', () => {
    $('[data-region-redirect-notification]').fadeOut(400);
  });
}
